import React from 'react';
import { useRequest } from 'ahooks';
import { Form, message, Modal, Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { endsWith } from 'lodash';
import { instance } from '../axios';

const { Item } = Form;

/**
 * visible
 * bsid
 * gh
 * onSubmit
 * onCancel
 */
export default ({ visible, gh, bsid, onSubmit, onCancel }) => {
  const [form] = Form.useForm();

  // 上传
  const { runAsync: upLoadFile, loading } = useRequest(
    (data) => {
      return instance({
        method: 'post',
        url: `addThesisReferenceBatch`,
        data,
      });
    },
    {
      manual: true,
    }
  );
  
  // 模板下载
  const { runAsync: runDownload } = useRequest(
    () => instance({
      method: 'get',
      url: `getThesisReferenceTemplate`,
      responseType: 'blob',
    }),
    {
    manual: true,
  });

  const onDownload = async () => {
    const res = await runDownload();
    const a = document.createElement('a');
    const blob = res?.data;
    a.style.display = 'none';
    a.href = URL.createObjectURL(blob); // 创建下载的链接
    a.download = '论文教参导入模板.xlsx'; // 下载后文件名
    document.body.appendChild(a);
    a.click(); // 点击下载
    document.body.removeChild(a); // 下载完成移除元素
  };

  const handleSubmit = async () => {
    const { file } = await form.validateFields();
    const formData = new FormData();
    formData.append('bsid', bsid);
    formData.append('gh', gh);
    formData.append('file', file?.fileList?.[0]?.originFileObj || undefined);
    const res = await upLoadFile(formData);
    if (res?.data?.code === 0) {
      message.success(`导入成功`);
      onSubmit();
    } else {
      message.error(res?.data?.message || '导入失败，请稍后重试')
    }
  };
  return (
    <Modal
      destroyOnClose
      visible={visible}
      title='批量添加电子论文'
      okText='确定'
      cancelText='取消'
      confirmLoading={loading}
      onCancel={onCancel}
      onOk={handleSubmit}
      style={{
        padding: '20px',
      }}
    >
      <Form form={form} autoComplete="off" labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
        
        <Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.file !== currentValues.file
          }
        >
          {({ getFieldValue }) => {
            return (
              <Item
                label="论文教参文件"
                name="file"
                rules={[
                  // { required: true, message: '' },
                  {
                    validator: async (_, value) => {
                      return new Promise((res, rej) => {
                        if (value?.fileList?.length) {
                          return res();
                        } else {
                          return rej('请选择附件');
                        }
                      });
                    },
                  },
                ]}
              >
                <Upload
                  accept='.xls,.xlsx'
                  maxCount={1}
                  fileList={getFieldValue('file')?.fileList || []}
                  beforeUpload={
                    (file) => {
                      if (!['.txt', '.iso', '.xls', '.xlsx'].some((e) => endsWith(file?.name, e))) {
                        message.warning('仅支持上传.xls,xlsx格式文件');
                        return Upload.LIST_IGNORE;
                      }
                      if (file.size === 0) {
                        message.warning('上传文件为空，请重新上传');
                        return Upload.LIST_IGNORE;
                      }
                      // const isLt2M = file.size / 1024 / 1024 < 5;
                      // if (!isLt2M) {
                      //   message.warning('文件大小超过5M，请重新上传');
                      //   return Upload.LIST_IGNORE;
                      // }
                      return false;
                    }
                  }
                >
                  <Button icon={<UploadOutlined />} style={{ color: '#666' }}>上传文件</Button>
                  {/* <p style={{ color: '#999' }}>支持扩展名：.xls .xlsx</p> */}
                </Upload>
              </Item>
            )
          }}
        </Item>

         <Item label='上传文件模板'>
          <Button type="link" onClick={onDownload} style={{ padding: '0' }}>
            论文教参导入模板.xlsx
          </Button>
        </Item>

      </Form>
    </Modal>
  );
};
